export default function getOfferAgreement({ offer, user }) {
	const { agreement: defaultAgreement } = user?.prices?.[offer.producer?.id]?.[offer.languageRole] || {};

	return !offer.agreement ? defaultAgreement : offer.agreement;
}
